// extracted by mini-css-extract-plugin
export var orderDetails = "_u3-2";
export var orderImage = "_u3-1";
export var orderMeta = "_u3-3";
export var orderSummary = "_u3-0";
export var rightArrow = "_u3-4";